import type { FC } from "react";
import { Box, Grid, Typography, Tooltip } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { SharedGridPageProps } from "../types/sharedGridPage";
import InfoIcon from "@mui/icons-material/Info";

const SharedGridPage: FC<SharedGridPageProps> = (props) => {
	return (
		<>
			<Helmet>
				<title>{props.title} | ContactCenter4All</title>
			</Helmet>
			<Box
				sx={{
					backgroundColor: "background.paper",
					minHeight: "100%",
					py: 8,
					...props.style,
				}}
			>
				<Box sx={{ mx: 3, my: 3, height: "100%" }}>
					<Grid container spacing={3} style={{ height: "100%" }}>
						<Grid
							alignItems="center"
							container
							spacing={2}
							item
							xs={12}
							style={{ height: "100%" }}
						>
							<Grid item>
								<Typography
									color="textPrimary"
									variant="h5"
									data-testid="page-title"
								>
									{props.title}
								</Typography>
							</Grid>
							{props.titleExtra && (
								<Grid item sx={{ display: "flex", alignItems: "center" }}>
									{props.titleExtra}
								</Grid>
							)}
							{props.info && (
								<Grid item>
									<Tooltip title={props.info}>
										<InfoIcon color="primary" />
									</Tooltip>
								</Grid>
							)}
							<Grid item width={1} style={{ height: "100%" }}>
								<Box sx={{ mt: 0, height: "100%" }}>
									{props.subComponent}
								</Box>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</>
	);
};

export default SharedGridPage;
